<template>
  <div>
    <email-quarantine-table
        ref="table"
        :url="indexUrl"
    ></email-quarantine-table>
    <dialog-form-wrapper></dialog-form-wrapper>
  </div>
</template>

<script>
import DialogFormWrapper from '../dialog-form-wrapper';
import EmailQuarantineTable from './table';

export default {
  components: {
    DialogFormWrapper,
    EmailQuarantineTable,
  },

  props: {
    indexUrl: null,
  },
}
</script>
